<template>
    <div id="app">
        <AppHeader ref="header" v-if="showHeader"/>
        <main>
            <router-view />
        </main>
        <AppFooter v-if="showFooter"/>

        <!-- 模态框 -->
        <LoginModal v-if="showLoginModal" @close="showLoginModal = false" @success="handleLoginSuccess"
            @switch-to-register="showRegisterModal = true; showLoginModal = false" />

        <RegisterModal v-if="showRegisterModal" @close="showRegisterModal = false" @success="handleRegisterSuccess"
            @switch-to-login="showLoginModal = true; showRegisterModal = false" />
    </div>
</template>

<script>
    import AppHeader from './components/Header.vue'
    import AppFooter from './components/Footer.vue'
    import LoginModal from './components/modals/LoginModal.vue'
    import RegisterModal from './components/modals/RegisterModal.vue'

    export default {
        name: 'App',
        components: {
            AppHeader,
            AppFooter,
            LoginModal,
            RegisterModal
        },
        data() {
            return {
                showLoginModal: false,
                showRegisterModal: false,
                user: null
            }
        },
        computed: {
            showHeader() {
              return this.$route.meta.showHeader !== false
            },
            showFooter() {
                return this.$route.meta.showFooter !== false
            }
        },
        watch: {
            // 核心修复：路由切换时动态绑定/解绑点击监听
            $route: {
                immediate: true,
                handler(to) {
                    document.removeEventListener('click', this.handleClickOutside);
                    if (to.meta.showHeader !== false) {
                        document.addEventListener('click', this.handleClickOutside);
                        console.log("路由显示header，绑定点击监听");
                    } else {
                        console.log("路由隐藏header，解绑点击监听");
                    }
                }
            }
        },
        methods: {
            handleLoginSuccess(user) {
                this.user = user
                this.showLoginModal = false
            },
            handleRegisterSuccess(user) {
                this.user = user
                this.showRegisterModal = false
            },
            // 优化后的点击外部关闭菜单方法
            handleClickOutside(event) {
                console.log("handleClickOutside")
                
                const headerComponent = this.$refs.header;
                if (!headerComponent) {
                    console.log("$refs.header不存在，直接返回");
                    return;
                }

                const headerElement = headerComponent.$el;
                if (!headerElement.contains(event.target) && typeof headerComponent.closeMobileMenu === 'function') {
                    headerComponent.closeMobileMenu();
                    console.log("执行closeMobileMenu成功");
                }
            }
        },
        provide() {
            return {
                app: this
            }
        },
        mounted() {
            // 检查本地存储的用户信息
            const savedUser = localStorage.getItem('user')
            if (savedUser) {
                this.user = JSON.parse(savedUser)
            }
        },
        beforeDestroy() {
            // 最终清理监听
            document.removeEventListener('click', this.handleClickOutside)
        }
    }
</script>

<style>
    /* 全局样式（保持不变） */
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }

    body {
        background-color: #f5f7fa;
        color: #333;
        line-height: 1.6;
    }

    .container {
        padding: 0 15px;
    }

    .btn-primary {
        background-color: #4dabf7;
        color: white;
        border: none;
        padding: 12px 30px;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    .btn-primary:hover {
        background-color: #3b99e0;
    }

    .btn-secondary {
        background-color: #e9ecef;
        color: #495057;
        border: none;
        padding: 12px 30px;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    .section-title {
        text-align: left;
        margin-bottom: 50px;
    }

    .section-title h2 {
        font-size: 32px;
        color: #1a3a5f;
        margin-bottom: 15px;
    }

    .section-title p {
        color: #666;
        max-width: 700px;
        margin: 0 0;
    }

    .form-group {
        margin-bottom: 20px;
    }

    .form-group label {
        display: block;
        margin-bottom: 8px;
        font-weight: 500;
        color: #1a3a5f;
    }

    .form-group select,
    .form-group input,
    .form-group textarea {
        width: 100%;
        padding: 12px 15px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 16px;
    }

    /* 响应式样式 */
    @media (max-width: 768px) {
        .section-title h2 {
            font-size: 28px;
        }
        body {
          overflow-x: hidden;
        }
        
        button, a {
          -webkit-tap-highlight-color: transparent;
        }
        
        .mobile-menu {
          min-height: 44px;
          min-width: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
    }
</style>